export default __webpack_public_path__ + "static/media/forecast_burger_icon.a305b7d5.png";